import { useQuery } from '@tanstack/react-query';
import { getDeliveryRecords } from '../services/api';
import { MATERIAL_NAME } from '../types';
import { money } from '../utils/format';
import { exportCsv } from '../utils/exportCsv';

export default function DeliveryRecords() {
  const { data, isLoading } = useQuery({
    queryKey: ['delivery-records'],
    queryFn: () => getDeliveryRecords(1000),
  });
  const records = data?.records ?? [];

  return (
    <div className="page-wrap">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Delivery history</h2>
        <button className="btn btn-sm" disabled={!records.length} onClick={() => exportCsv('delivery-records.csv', records as any)}>
          Export CSV
        </button>
      </div>
      <p className="muted">These records feed the freight-curve fit (last 6 months, haul_fee &gt; 0).</p>
      {isLoading ? (
        <p className="muted">Loading…</p>
      ) : (
        <table className="data-table card" style={{ display: 'table' }}>
          <thead>
            <tr>
              <th>Date</th>
              <th>From</th>
              <th>To</th>
              <th>Material</th>
              <th style={{ textAlign: 'right' }}>Haul fee</th>
              <th style={{ textAlign: 'right' }}>Qty</th>
            </tr>
          </thead>
          <tbody>
            {records.map((r) => (
              <tr key={r.id}>
                <td>{r.delivery_date}</td>
                <td>{[r.yard_city, r.yard_state].filter(Boolean).join(', ')}</td>
                <td>{[r.site_city, r.site_state].filter(Boolean).join(', ')}</td>
                <td>{r.material ? MATERIAL_NAME[r.material] ?? r.material : '—'}</td>
                <td style={{ textAlign: 'right' }}>{money(r.haul_fee)}</td>
                <td style={{ textAlign: 'right' }}>{r.quantity ?? '—'}</td>
              </tr>
            ))}
            {records.length === 0 && (
              <tr>
                <td colSpan={6} className="muted">
                  No records yet — import some on the Import page.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
